import type { MFAFactor } from "@fmc-digital/core-auth";
import { t } from "@fmc-digital/i18n";
import {
  processEmailForDisplay,
  extractLastFourDigits,
} from "@profile/features/registration/mfa-formatting";

/**
 * Format factor label based on type and profile
 * Atom-level utility function for formatting MFA factor labels
 */
export function formatFactorLabel(factor: MFAFactor): string {
  switch (factor.factorType) {
    case "sms":
      if (factor.profile?.phoneNumber) {
        const lastFour = extractLastFourDigits(factor.profile.phoneNumber);
        return t("auth.mfa.smsLabelWithPhone", { lastFour });
      }
      return t("auth.mfa.smsLabel");
    case "email":
      if (factor.profile?.email) {
        const processedEmail = processEmailForDisplay(factor.profile.email);
        return t("auth.mfa.emailLabelWithAddress", {
          email: processedEmail,
        });
      }
      return t("auth.mfa.emailVerificationLabel");
    case "call":
    case "push":
    case "token:software:totp":
    case "token:hardware":
    case "question":
    case "webauthn":
      return factor.factorType;
    default: {
      const _exhaustive: never = factor.factorType;
      return _exhaustive;
    }
  }
}
